import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaginatedListNavigation from '../paginatedlist/PaginatedListNavigation/PaginatedListNavigation';
import {
  refreshFilteredChannelList,
  selectChannelListColumnVisibility,
  selectChannelListPageNo,
  selectChannelListRowsPerPage,
  selectChannelListTotalResults,
  setChannelListPage,
  setColumnVisibility,
  setRowsPerPage,
} from '../../redux/slices/channelListSlice/channelListSlice';

function PaginatedChannelListNavigation() {
  const channelListColumns = useSelector((state) => selectChannelListColumnVisibility(state));
  const channelListNumRows = useSelector((state) => selectChannelListRowsPerPage(state));
  const pageNo = useSelector((state) => selectChannelListPageNo(state));
  const totalNumRecords = useSelector((state) => selectChannelListTotalResults(state));
  const dispatch = useDispatch();

  return (
    <div>
      <PaginatedListNavigation
        columnVisibility={channelListColumns}
        currentPage={pageNo}
        onNextPage={() => {
          dispatch(setChannelListPage(pageNo + 1));
          dispatch(refreshFilteredChannelList());
        }}
        onPrevPage={() => {
          dispatch(setChannelListPage(pageNo - 1));
          dispatch(refreshFilteredChannelList());
        }}
        onToggleColumn={(name, visible) => dispatch(
          setColumnVisibility({ columnName: name, visible }),
        )}
        totalResults={totalNumRecords}
        rowsPerPage={channelListNumRows}
        setRowsPerPage={(value) => {
          dispatch(setRowsPerPage(value));
          dispatch(refreshFilteredChannelList());
        }}
      />
    </div>
  );
}

export default PaginatedChannelListNavigation;
